export enum UserType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY'
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  RESTRICTED = "RESTRICTED",
  TEMP_DEACTIVATED = "TEMP_DEACTIVATED",
}

export enum SynapsStatus {
  NULL = 'NULL',
  NEW = 'NEW',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  RESUBMISSION_REQUIRED = 'RESUBMISSION_REQUIRED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  RESET = 'RESET',
  COMPLETED = 'COMPLETED',
}

export enum SumsubStatus {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  FAILED = 'FAILED',
}

export enum TravelRuleStatus {
  NEEDED = 'NEEDED',
  FAILED = 'FAILED',
  SENT = 'SENT',
  COMPLETED = 'COMPLETED',
}

export enum OnboardingStep {
  FINANCIAL = 'financial',
  LEGAL = 'legal',
  MANDATE = 'mandate'
}
